<!-- 范围列表 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false"
            append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
            <scopeManagementAction v-if="showStatus" ref="scopeManagementAction" @drawerCancel="drawerCancel"
                :actionData="actionData"></scopeManagementAction>
        </el-drawer>

        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getDataList" :showRefresh="true" :buttonFlag="false"></v-button>
            <div class="page_content_top_line">
                <el-form :inline="true" :model="getRequestData" class="demo-form-inline" size="mini" label-width="100px">
                    <el-form-item label="范围名称">
                        <label slot="label" :style="$common.labelStyle('范围名称')" v-html="$common.htmlLabel('范围名称')"></label>
                        <el-input class="form_codition" v-model.trim="getRequestData.scopeName" clearable
                            :maxlength="$store.state.inputLength"></el-input>
                    </el-form-item>
                    <el-form-item label="范围类型">
                        <label slot="label" :style="$common.labelStyle('范围类型')" v-html="$common.htmlLabel('范围类型')"></label>
                        <el-select class="form_codition" v-model="getRequestData.scopeType" placeholder="请选择范围类型" clearable>
                            <el-option v-for="item in scopeList" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page_content_center">
            <el-table stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border
                style="width: 100%" highlight-current-row size="mini">
                <el-table-column align="center" label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="scopeName" label="范围名称">
                    <template slot="header">
                        <div>
                            <el-tooltip :disabled="isShowTooltip" content="范围名称" placement="top">
                                <div class="long_title"><span ref="scopeName">范围名称</span></div>
                            </el-tooltip>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.scopeName }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="scopeType" label="范围类型">
                    <template slot="header">
                        <div>
                            <el-tooltip :disabled="isShowTooltip" content="范围类型" placement="top">
                                <div class="long_title"><span ref="scopeType">范围类型</span></div>
                            </el-tooltip>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ getScopeType(scope.row.scopeType) }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" sortable show-overflow-tooltip prop="scopeSort" label="排序"></el-table-column>
            </el-table>
        </div>
        <!-- <div class="page_content_bottom">
        <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber" :current-page="getRequestData.page" :page-sizes="[30,50,100,500]" :page-size="30" layout="total, sizes, prev, pager, next, jumper" :total="returnData.total">
        </el-pagination>
    </div> -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth"
                @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../byComponents/SearchScheme.vue";
import scopeManagementAction from '@/components/scopeManagementAction.vue'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        scopeManagementAction,
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                scopeName: "",
                scopeType: "",
            },
            returnData: {
                list: [],
            },
            scopeList: [
                {
                    value: 0,
                    label: "生产范围",
                },
                {
                    value: 1,
                    label: "经营范围",
                },
                {
                    value: 2,
                    label: "诊疗范围",
                },
            ], //范围类型列表
            buttonList: [],
            selectedDataIndex: 0,
            seId: "",
            seTitle: "",
            seWidth: "",
            DialogVisible: false,
            seType: "",
            isShowTooltip: false,
            showStatus: false,
            actionData: {},
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 子组件触发
        drawerCancel() {
            this.showStatus = false;
            this.getDataList();
        },
        // 点击穿透字段 传参单号
        // toDetail(orderId) {
        //     if (orderId) {
        //         // 设置为true 打开穿透组件首页
        //         var isPenetrate = true
        //         // 设置缓存 存入点击单号
        //         this.resetSetItem('penetrateOrderId', orderId);
        //         // 与父级跨域通信 传递isPenetrate参数
        //         window.parent.postMessage({ //向窗口发送MessageEvent消息
        //             cmd: 'returnFormJson',
        //             params: {
        //                 isPenetrate
        //             } //参数
        //         }, '*');
        //     }
        // },

        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type) {
            this.DialogVisible = true;
            this.seId = sId;
        },
        //返回数据
        changeInputModel(val) {
            console.log(val);

            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.getRequestData.scopeName = val.scopeName;
                this.getRequestData.opmId = val.opmId;
            }
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },

        isShowData(name, value) {
            switch (name) {
                case "supplier":
                    var dataInfo = sessionStorage.getItem("selectSupplierData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.getRequestData.opmId = dataInfo.opmId;
                        this.getRequestData.scopeName = dataInfo.scopeName;
                    }
                    break;
            }
        },

        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true;
                    this.actionData = {
                        cate: 0,
                        formData: "0",
                        oldData: "",
                        orderId: "",
                        printSouce: "",
                        printJurId: "",
                    };
                    break;
                case 1:
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.showStatus = true;
                    this.actionData = {
                        cate: 1,
                        formData: "1",
                        oldData: dataInfo,
                        orderId: dataInfo.discId,
                        printSouce: "",
                        printJurId: "",
                    };
                    break;
                case 2:
                    this.delDataAction();
                    break;

                case 8:
                    // this.showPrintPlan()
                    break;
            }
        },
        showPrintPlan() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                var info = this.returnData.list[this.selectedDataIndex];
                this.$refs.printPlan.openDia(info.discId);
            } else {
                return;
            }
        },
        // 删除数据
        delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }

            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.discId],
                    };
                    let responseData = await this.$http.dictscopeDeleteScope(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getDictscopeQueryScopeAll(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        async getButtonList() {
            this.buttonList = await this.$common.getActionButton();
        },

        // 获取范围类型
        getScopeType(str) {
            str = parseFloat(str);
            //范围类型0.生产范围1.经营范围2.诊疗范围
            switch (str) {
                case 0:
                    return "生产范围";
                case 1:
                    return "经营范围";
                case 2:
                    return "诊疗范围";
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getDataList();
        this.getButtonList();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-drawer {
    outline: none;
}
</style>
